import React from 'react'
import PropTypes  from 'prop-types';
import {Link as ImageRouterLink} from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Typography } from '@material-ui/core'

const useStyles= makeStyles(theme=>({
    avatar: {
        width:90,
        height:90
    },
    root:{
        display: 'flex',
        // justifyContent: 'center'
        alignItems: 'center',
        flexDirection: 'column'
    },
    name:{
        marginTop: theme.spacing(1)
    }
}))

function Profile(props) {
    const {className, ...rest} = props
    const classes = useStyles()
    const user= {
        name: 'Alexa',
        imageSrc: '/images/avatars/image1.jpg',
        designation: 'Management Director'
    }
    return (
        <div
        {...rest}
        className={classes.root}
        >
            <ImageRouterLink to="/">
                <Avatar 
                alt= {`logo-${user.name}`} 
                src= {user.imageSrc}
                className={classes.avatar}
                />
            </ImageRouterLink>
            <Typography variant="h4" className={classes.name}>
                {user.name}
            </Typography>
            <Typography variant="body1">
                {user.designation}
            </Typography>

        </div>
    )
}

export default Profile
